/**
 * portfolio.js — Filterable portfolio grid component
 * Renders from home.json `portfolio` array
 */

export function getPortfolioHTML(portfolioItems = []) {
  if (!portfolioItems.length) return '';

  const categories = ['all', ...new Set(portfolioItems.map(p => p.category))];

  const filterTabsHTML = categories.map(cat => `
    <button class="filter-tab ${cat === 'all' ? 'active' : ''}"
            data-filter="${cat}"
            id="filter-tab-${cat}">
      ${cat.charAt(0).toUpperCase() + cat.slice(1)}
    </button>
  `).join('');

  const CATEGORY_EMOJI = {
    web: '🌐',
    mobile: '📱',
    design: '🎨',
    cloud: '☁️'
  };

  const cardsHTML = portfolioItems.map((project, i) => {
    const tagsHTML = project.tags.map(tag => `<span class="portfolio-tag">${tag}</span>`).join('');
    const emoji = CATEGORY_EMOJI[project.category] || '✦';
    return `
      <div class="portfolio-card animate-on-scroll"
           data-category="${project.category}"
           id="portfolio-card-${i}"
           style="animation-delay: ${(i % 3) * 0.1}s;">
        <div class="portfolio-card-img-placeholder">${emoji}</div>
        <div class="portfolio-card-body">
          <div class="portfolio-card-tags">${tagsHTML}</div>
          <h3>${project.name}</h3>
          <p>${project.description}</p>
        </div>
      </div>
    `;
  }).join('');

  return `
    <div class="section-header animate-on-scroll">
      <span class="section-eyebrow">Our Work</span>
      <h2 class="text-hero-display" style="font-size: clamp(2rem, 4vw, 3.25rem); margin-bottom: 1rem;">
        Projects We're Proud Of
      </h2>
      <p style="font-size: 1.1rem; color: var(--text-secondary); max-width: 560px; margin: 0 auto;">
        A curated selection of web, mobile, and design work — built to perform and crafted to last.
      </p>
    </div>

    <div class="filter-tabs" id="portfolio-filters">
      ${filterTabsHTML}
    </div>

    <div class="portfolio-grid" id="portfolio-grid">
      ${cardsHTML}
    </div>

    <div style="text-align: center; margin-top: 3rem;">
      <a href="/#contactUs" class="btn btn-outline">
        Start Your Project ↗
      </a>
    </div>
  `;
}

export function bindPortfolioFilters() {
  const tabs = document.querySelectorAll('.filter-tab');
  const cards = document.querySelectorAll('.portfolio-card');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const filter = tab.getAttribute('data-filter');

      // Update active tab
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      // Filter cards
      cards.forEach(card => {
        const category = card.getAttribute('data-category');
        const show = filter === 'all' || category === filter;

        if (show) {
          card.classList.remove('hidden');
          card.classList.add('animate-filter-in');
          // Remove animation class after it runs so re-filter works
          card.addEventListener('animationend', () => {
            card.classList.remove('animate-filter-in');
          }, { once: true });
        } else {
          card.classList.add('hidden');
        }
      });
    });
  });
}
